import { render, staticRenderFns } from "@/manager/purchase/views/convocation-detail/purchase-list/purchase-list.pug?vue&type=template&id=d56308be&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/manager/purchase/views/convocation-detail/purchase-list/purchase-list.scss?vue&type=style&index=0&id=d56308be&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56308be",
  null
  
)

export default component.exports